import React from 'react';
import Button from './Button';
import { t } from 'i18next';
import { play } from '../../hooks/useSound';

const Modal = ({ show, title, children, onClose, onSubmit, hideFooter = false, submitText }) => {
  const prevShow = React.useRef(false);
  React.useEffect(() => {
    if (show && !prevShow.current) play('modal-open');
    else if (!show && prevShow.current) play('modal-close');
    prevShow.current = show;
  }, [show]);

  if (!show) return null;

  return (
    <div className="modal fade show d-block" tabIndex="-1" role="dialog" aria-modal="true">
      <div className="modal-dialog" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">{title}</h5>
            <button type="button" className="btn-close" onClick={onClose}></button>
          </div>
          <div className="modal-body">{children}</div>

          {!hideFooter && (
            <div className="modal-footer">
              <Button onClick={onClose} theme="secondary" styles={{}} mb="0">
                {t('cancel')}
              </Button>
              <Button onClick={onSubmit} styles={{}} mb="0">
                {t(submitText || 'save')}
              </Button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Modal;
